import { GetterTree } from 'vuex';
import { ProjectsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ProjectsState, RootState> = {
  projectWithId: (state) => (id: string) => {
    return state.projects.find((project) => project.id === id);
  },
  filter: (state) => (searchString: string) => {
    const searchArray = searchString.toLowerCase().split(' ');
    return state.projects.filter((project) => {
      const adminEmails = (project.administrator || []).map((admin) => admin.email?.toLowerCase()).join(' ');

      const guestEmails = (project.guest || []).map((guest) => guest.email?.toLowerCase()).join(' ');

      const projectTextIndex =
        project.name.toLowerCase() +
        ' ' +
        (project.city && project.city.name ? project.city.name.toLowerCase() : '') +
        ' ' +
        (project.tags?.join(' ') ?? '') +
        ' ' +
        (project.owner ? `${project.owner.firstname?.toLowerCase()} ${project.owner.lastname?.toLowerCase()}` : '') +
        ' ' +
        (project.owner ? project.owner.email?.toLowerCase() : '') +
        ' ' +
        adminEmails +
        ' ' +
        guestEmails;

      return searchArray.every((searchWord) => {
        return projectTextIndex.indexOf(searchWord) > -1;
      });
    });
  },
};
